var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDowncloseGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2376 0.651731C19.8822 0.234301 19.4013 0 18.9001 0C18.3988 0 17.918 0.234301 17.5625 0.651731L10.7514 8.58566L4.03515 0.651731C3.67967 0.234301 3.19881 0 2.69759 0C2.19636 0 1.7155 0.234301 1.36003 0.651731C1.1822 0.860081 1.04106 1.10796 0.944739 1.38108C0.848418 1.65419 0.798828 1.94713 0.798828 2.243C0.798828 2.53887 0.848418 2.83181 0.944739 3.10492C1.04106 3.37803 1.1822 3.62592 1.36003 3.83427L9.40435 13.3371C9.58072 13.5471 9.79056 13.7139 10.0218 13.8276C10.253 13.9414 10.5009 14 10.7514 14C11.0019 14 11.2498 13.9414 11.481 13.8276C11.7122 13.7139 11.9221 13.5471 12.0984 13.3371L20.2376 3.83427C20.4154 3.62592 20.5566 3.37803 20.6529 3.10492C20.7492 2.83181 20.7988 2.53887 20.7988 2.243C20.7988 1.94713 20.7492 1.65419 20.6529 1.38108C20.5566 1.10796 20.4154 0.860081 20.2376 0.651731Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowncloseGrey);
export default __webpack_public_path__ + "static/media/downclose_grey.e257ec2e163fe9b20479696c4aa74f9c.svg";
export { ForwardRef as ReactComponent };